"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _antd = require("antd");

var _IntlMessage = _interopRequireDefault(require("../util-components/IntlMessage"));

var _Icon = _interopRequireDefault(require("../util-components/Icon"));

var _NavigationConfig = _interopRequireDefault(require("../../configs/NavigationConfig"));

var _reactRedux = require("react-redux");

var _ThemeConstant = require("../../constants/ThemeConstant");

var _utils = _interopRequireDefault(require("../../utils"));

var _Theme = require("../../redux/actions/Theme");

var SubMenu = _antd.Menu.SubMenu;
var useBreakpoint = _antd.Grid.useBreakpoint;

var setLocale = function setLocale(isLocaleOn, localeKey) {
  return isLocaleOn ? /*#__PURE__*/_react.default.createElement(_IntlMessage.default, {
    id: localeKey
  }) : localeKey.toString();
};

var setDefaultOpen = function setDefaultOpen(key) {
  var keyList = [];
  var keyString = "";

  if (key) {
    var arr = key.split("-");

    for (var index = 0; index < arr.length; index++) {
      var elm = arr[index];
      index === 0 ? keyString = elm : keyString = "".concat(keyString, "-").concat(elm);
      keyList.push(keyString);
    }
  }

  return keyList;
};

var SideNavContent = function SideNavContent(props) {
  var sideNavTheme = props.sideNavTheme,
      routeInfo = props.routeInfo,
      hideGroupTitle = props.hideGroupTitle,
      localization = props.localization,
      onMobileNavToggle = props.onMobileNavToggle;
  var isMobile = !_utils.default.getBreakPoint(useBreakpoint()).includes('lg');

  var closeMobileNav = function closeMobileNav() {
    if (isMobile) {
      onMobileNavToggle(false);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_antd.Menu, {
    theme: sideNavTheme === _ThemeConstant.SIDE_NAV_LIGHT ? "light" : "dark",
    mode: "inline",
    style: {
      height: "100%",
      borderRight: 0
    },
    defaultSelectedKeys: [routeInfo === null || routeInfo === void 0 ? void 0 : routeInfo.key],
    defaultOpenKeys: setDefaultOpen(routeInfo === null || routeInfo === void 0 ? void 0 : routeInfo.key),
    className: hideGroupTitle ? "hide-group-title" : ""
  }, _NavigationConfig.default.map(function (menu) {
    return menu.submenu.length > 0 ? /*#__PURE__*/_react.default.createElement(_antd.Menu.ItemGroup, {
      key: menu.key,
      title: setLocale(localization, menu.title)
    }, menu.submenu.map(function (subMenuFirst) {
      return subMenuFirst.submenu.length > 0 ? /*#__PURE__*/_react.default.createElement(SubMenu, {
        icon: subMenuFirst.icon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
          type: subMenuFirst === null || subMenuFirst === void 0 ? void 0 : subMenuFirst.icon
        }) : null,
        key: subMenuFirst.key,
        title: setLocale(localization, subMenuFirst.title)
      }, subMenuFirst.submenu.map(function (subMenuSecond) {
        return /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
          key: subMenuSecond.key
        }, subMenuSecond.icon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
          type: subMenuSecond === null || subMenuSecond === void 0 ? void 0 : subMenuSecond.icon
        }) : null, /*#__PURE__*/_react.default.createElement("span", null, setLocale(localization, subMenuSecond.title)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          onClick: function onClick() {
            return closeMobileNav();
          },
          to: subMenuSecond.path
        }));
      })) : /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
        key: subMenuFirst.key
      }, subMenuFirst.icon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        type: subMenuFirst.icon
      }) : null, /*#__PURE__*/_react.default.createElement("span", null, setLocale(localization, subMenuFirst.title)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        onClick: function onClick() {
          return closeMobileNav();
        },
        to: subMenuFirst.path
      }));
    })) : /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
      key: menu.key
    }, menu.icon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: menu === null || menu === void 0 ? void 0 : menu.icon
    }) : null, /*#__PURE__*/_react.default.createElement("span", null, setLocale(localization, menu === null || menu === void 0 ? void 0 : menu.title)), menu.path ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      onClick: function onClick() {
        return closeMobileNav();
      },
      to: menu.path
    }) : null);
  }));
};

var TopNavContent = function TopNavContent(props) {
  var topNavColor = props.topNavColor,
      localization = props.localization;
  return /*#__PURE__*/_react.default.createElement(_antd.Menu, {
    mode: "horizontal",
    style: {
      backgroundColor: topNavColor
    }
  }, _NavigationConfig.default.map(function (menu) {
    return menu.submenu.length > 0 ? /*#__PURE__*/_react.default.createElement(SubMenu, {
      key: menu.key,
      popupClassName: "top-nav-menu",
      title: /*#__PURE__*/_react.default.createElement("span", null, menu.icon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        type: menu === null || menu === void 0 ? void 0 : menu.icon
      }) : null, /*#__PURE__*/_react.default.createElement("span", null, setLocale(localization, menu.title)))
    }, menu.submenu.map(function (subMenuFirst) {
      return subMenuFirst.submenu.length > 0 ? /*#__PURE__*/_react.default.createElement(SubMenu, {
        key: subMenuFirst.key,
        icon: subMenuFirst.icon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
          type: subMenuFirst === null || subMenuFirst === void 0 ? void 0 : subMenuFirst.icon
        }) : null,
        title: setLocale(localization, subMenuFirst.title)
      }, subMenuFirst.submenu.map(function (subMenuSecond) {
        return /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
          key: subMenuSecond.key
        }, /*#__PURE__*/_react.default.createElement("span", null, setLocale(localization, subMenuSecond.title)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: subMenuSecond.path
        }));
      })) : /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
        key: subMenuFirst.key
      }, subMenuFirst.icon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        type: subMenuFirst === null || subMenuFirst === void 0 ? void 0 : subMenuFirst.icon
      }) : null, /*#__PURE__*/_react.default.createElement("span", null, setLocale(localization, subMenuFirst.title)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: subMenuFirst.path
      }));
    })) : /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
      key: menu.key
    }, menu.icon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: menu === null || menu === void 0 ? void 0 : menu.icon
    }) : null, /*#__PURE__*/_react.default.createElement("span", null, setLocale(localization, menu === null || menu === void 0 ? void 0 : menu.title)), menu.path ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: menu.path
    }) : null);
  }));
};

var MenuContent = function MenuContent(props) {
  return props.type === _ThemeConstant.NAV_TYPE_SIDE ? /*#__PURE__*/_react.default.createElement(SideNavContent, props) : /*#__PURE__*/_react.default.createElement(TopNavContent, props);
};

var mapStateToProps = function mapStateToProps(_ref) {
  var theme = _ref.theme;
  var sideNavTheme = theme.sideNavTheme,
      topNavColor = theme.topNavColor;
  return {
    sideNavTheme: sideNavTheme,
    topNavColor: topNavColor
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  onMobileNavToggle: _Theme.onMobileNavToggle
})(MenuContent);

exports.default = _default;